// GSAP version of LoopScene's CSS beats. Gets gsap and the <svg>, returns the timeline.
export default function timeline(gsap, root) {
  const q = (n) => root.querySelector(`[data-anim="${n}"]`);
  const chips = [0, 1, 2].map((i) => q(`chip-${i}`));
  return gsap.timeline({ defaults: { ease: 'power2.out' } })
    .from(root.querySelectorAll('.trail'), { strokeDashoffset: 24, duration: 1.8, ease: 'none' }, 0)
    .fromTo(q('dot-in'), { opacity: 1, x: 0 }, { x: 38, duration: 0.8, ease: 'power1.in' }, 0.3)
    .to(q('dot-in'), { opacity: 0, duration: 0.12 }, 1.0)
    .to(q('hub'), { scale: 1.08, svgOrigin: '400 72', duration: 0.22, yoyo: true, repeat: 1 }, 1.1)
    .from(chips, { opacity: 0, x: -14, scale: 0.6, transformOrigin: '0% 50%', stagger: 0.12, duration: 0.45, ease: 'back.out(3)' }, 1.2)
    .fromTo(q('dot-out'), { opacity: 1, x: 0 }, { x: -20, duration: 0.5 }, 1.75)
    .to(q('dot-out'), { opacity: 0, duration: 0.1 }, 2.2)
    .fromTo(q('glow'), { opacity: 0, scale: 0.4 }, { opacity: 0.28, scale: 1, transformOrigin: '50% 50%', duration: 0.9, ease: 'elastic.out(1, 0.5)' }, 2.2);
}
